import axios from 'axios';

export default {

    getSsoUri() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/sso');
    },

    postSsoReturn(code) {
        return axios.post(process.env.VUE_APP_API_URI + '/api/sso/reply', {
            code: code
        });
    },
}
